import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import { BannersProvider } from '../../contexts';
import { SidebarLayout } from '../../layouts';
import { PermissionsGuard } from './Components';
import { Loader } from './loader.routes';

const BannersList = Loader(lazy(() => import('../../content/pages/Banners/BannersList')));

export const createBannersRoutes = () => ({
  path: 'banners',
  element: <SidebarLayout />,
  children: [
    {
      path: '',
      element: (
        <PermissionsGuard allowedPermissions={['bannerView']} should404>
          <Navigate to="/banners/list" replace />
        </PermissionsGuard>
      )
    },
    {
      path: 'list',
      element: (
        <PermissionsGuard allowedPermissions={['bannerView']} should404>
          <BannersProvider>
            <BannersList />
          </BannersProvider>
        </PermissionsGuard>
      )
    }
  ]
});
